export default __webpack_public_path__ + "static/photo2usluge-0ad6c1992e9c24a2b259dc2eadd13a4a.png";